import Vue from 'vue'
import selectCheckListDialog from './selectCheckListDialog.vue'

let selectCheckListDialogConstructor = Vue.extend(selectCheckListDialog)
let instance

const selectTip = function(options = {}) {
  instance = new selectCheckListDialogConstructor({
    data: options
  })
  document.body.appendChild(instance.$mount().$el)
}

// export default importTip
export default {
  install (Vue, options) {
    Vue.prototype.$selectCheckList = selectTip
  }
}


// WEBPACK FOOTER //
// ./src/components/selectCheckList/selectCheckList.js